// extracted by mini-css-extract-plugin
export var columnItem = "_di-3";
export var columnItemDraggable = "_di-4";
export var dragHandle = "_di-0";
export var dragHandleHovered = "_di-1";
export var dropdown = "_di-5";
export var dropdownContent = "_di-7";
export var dropdownInner = "_di-6";
export var filterDropdownHeader = "_di-8";
export var icon = "_di-2";
export var sectionDivider = "_di-9";